import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { onEnterOrSpacePress } from '@hivebrite/utils';
import { Box } from "../../box/src";
import { CATEGORIES, FontAwesomeIcon } from "../../font-awesome-icon/src";
import { focusOutline } from "../../theme/src";
const ICON_PROPORTION = 42;
const LEFT_PADDING_PROPORTION = 6.6;
export const Play = ({ ariaLabel, onClick, size = 48 }) => {
    var _a;
    const iconSize = Number(size) * (ICON_PROPORTION / 100);
    const paddingLeft = Number(size) * (LEFT_PADDING_PROPORTION / 100);
    const a11yText = ariaLabel ||
        ((_a = window === null || window === void 0 ? void 0 : window.__) === null || _a === void 0 ? void 0 : _a.call(window, 'Start the video preview')) ||
        'Start the video preview';
    return (_jsx(Wrapper, { "aria-label": a11yText, "data-testid": "ds-play", height: size, onClick: onClick, onKeyPress: onEnterOrSpacePress(onClick), pl: `${paddingLeft}px`, role: "button", tabIndex: 0, width: size, children: _jsx(FontAwesomeIcon, { color: "white", height: `${iconSize}px`, iconName: "play", iconType: CATEGORIES.SOLID }) }));
};
const Wrapper = styled(Box).attrs(() => ({
    alignItems: 'center',
    bg: 'primary',
    justifyContent: 'center',
})) `
  ${focusOutline}
  cursor: pointer;
  border-radius: 50%;
  user-select: none;
  &:hover,
  &:focus {
    background: ${({ theme }) => theme.colors.primaryDark};
  }
`;
//# sourceMappingURL=Play.js.map